import { useCallback, useEffect } from 'react'

import { useFtuCompletion } from '../hooks/useFtuCompletion'
import { useFtuStepMachine } from '../hooks/useFtuStepMachine'

import { trackEvent } from '@/utils/analytics'

import { FTU_ANALYTICS } from '../constants/constants'
import type { FtuConfig } from '../types/types'
import { FtuStepCard } from './FtuStepCard'

interface FtuTourIProps {
  ftu: FtuConfig
}

/**
 * Drives a single FTU config:
 * - owns the step machine
 * - records analytics
 * - marks the tour complete when finished
 *
 * Rendered by FtuManager for the one active FTU.
 */
export const FtuTour = ({ ftu }: FtuTourIProps) => {
  const { markCompleted } = useFtuCompletion()

  const handleFinish = useCallback(() => {
    trackEvent(FTU_ANALYTICS.completed, { ftu_id: ftu.id })
    markCompleted(ftu.id)
  }, [ftu.id, markCompleted])

  const machine = useFtuStepMachine(ftu, handleFinish)
  const currentStepId = machine.currentStep.id

  useEffect(() => {
    trackEvent(FTU_ANALYTICS.started, { ftu_id: ftu.id })
  }, [ftu.id])

  useEffect(() => {
    trackEvent(FTU_ANALYTICS.stepViewed, {
      ftu_id: ftu.id,
      step_id: currentStepId,
    })
  }, [ftu.id, currentStepId])

  return <FtuStepCard machine={machine} />
}
